import { computed } from 'vue'

import type { Ref } from 'vue'

import { usePip } from './pip/pip.hook'
import { useTracksLiveKit } from './tracks-live-kit.hook'
import { useRoomLiveKit } from './room-live-kit.hook'

interface ClassroomPipReturn {
  isSupported: boolean
  isActive: Ref<boolean>
  toggle: () => Promise<void>
}

export const useClassroomPip = (): ClassroomPipReturn => {
  const tracks = useTracksLiveKit()
  const { remoteIdentities } = useRoomLiveKit()

  const tutorTrack = computed<MediaStreamTrack | null>(() =>
    tracks.isRemoteCameraMuted.value ? null : (tracks.remoteCameraTrack.value?.mediaStreamTrack ?? null),
  )
  const studentTrack = computed<MediaStreamTrack | null>(() =>
    tracks.isCameraEnabled.value ? (tracks.localCameraTrack.value?.mediaStreamTrack ?? null) : null,
  )
  const tutorPresent = computed<boolean>(() => remoteIdentities.value.length > 0)

  return usePip({
    tutorTrack,
    studentTrack,
    tutorPresent,
    micEnabled: tracks.isMicEnabled,
    camEnabled: tracks.isCameraEnabled,
    onToggleMic: () => { void tracks.toggleMic() },
    onToggleCam: () => { void tracks.toggleCamera() },
  })
}
